import RetailerPeriodEdit from './RetailerPeriodEdit'
import RetailerPeriodList from './RetailerPeriodList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: RetailerPeriodList,
    edit: RetailerPeriodEdit
}
